<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <app-bar :title="`Thống kê sim không phát sinh dung lượng`" />
        <v-flex xs12 sm12 md12 lg12 xl12>
          <v-card>
            <v-card-text class="pa-10">
              <v-layout row wrap>
                <v-flex xs12 sm4 offset-sm2>
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="fromDate"
                        label="Từ ngày"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="fromDate" @input="menu1 = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="toDate"
                        label="Đến ngày"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="toDate" @input="menu2 = false"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 xl12>
          <v-card flat>
            <v-card-text class="pa-0">
              <sim-data :isLoading="isLoading" :datasource="simList" />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as Utils from '@/utils';
import AppBar from '@/components/appbar';
import SimData from './components/DataList';
import moment, { months } from 'moment';
import * as DateTimeUtil from '@/utils/datetime';

export default {
  components: {
    AppBar,
    SimData
  },
  data () {
    return {
      fromDate: moment().add(-1, 'months').format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      menu1: false,
      menu2: false,
      simList: [],
      isLoading: false,
    };
  },
  watch: {
    fromDate () {
      this.getData();
    },    
    toDate () {
      this.getData();
    }
  },
  mounted () {
    this.getData();
  },
  methods: {
    ...mapActions(['getSimDataByTime']),
    async getData () {
      this.isLoading = true;
      let fromTime = DateTimeUtil.convertDateTimeToSecond2010(this.fromDate);
      let toTime = DateTimeUtil.convertDateTimeToSecond2010(this.toDate);
      let res = await this.getSimDataByTime({ fromTime, toTime });

      if (res && res.length > 0) {
        let list = [];
        res.map((a, index) => {
          let item = {
            stt: ++index,
            phone: a.phone,
            iccId: a.iccId,
            activatedDate: DateTimeUtil.formatSecondToYYMMDD(a.telcoActivationDate),
            data: a.data[0].data,
            dataTime: DateTimeUtil.formatSecondToYYMMDD(a.data[0].dataTime)
          };
          list.push(item);
          return 0;
        });
        this.simList = list;
        this.isLoading = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/sim/DataReporting.vue